query BaseQuery {
  base: entry(uri: "__home__", site: "en") {
    siteId
    language
    localized {
      siteId
      language
    }
  }
}
